<ng-template #buildingTemplate>
  <vex-page-layout>
    <vex-page-layout-header class="pb-4" fxLayout="column" fxLayoutAlign="center start"></vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">
      <div class="card overflow-auto -mt-16">
        <base-data-table-header
          [label]="entityName"
          [loading]="loading"
          [showArchives]="canShowArchivePermission"
          [showArchived]="isArchive"
          (onSearchChange)="onSearchChange($event)"
          (onClearTextFilter)="clearTextFilter()"
          (onShowArchived)="onShowArchived($event)"
          (onCreate)="createItem()"
          [canImport]="false"
          [canCreate]="false"
          (onImport)="importItems()"
          [templates]="[{ template: advancedFilters, position: 2, place: 'before' }]"
          [createPermission]="[ENUM_PERMISSION.CREATE_BUILDING]"
          [importPermission]="[ENUM_PERMISSION.CREATE_BUILDING]"
        ></base-data-table-header>

        <base-data-table
          [count]="count"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [feisColumns]="feisColumns"
          [routerLinkDetailRow]="routerLinkDetailRow"
          [stickyTop]="true"
          (onPageEvent)="pageEvent($event)"
          (onSortEvent)="sortEvent($event)"
          (onUpdateItem)="updateItem($event)"
          (onDeleteItem)="deleteItem($event)"
        ></base-data-table>
      </div>
    </vex-page-layout-content>
  </vex-page-layout>
  <ng-template #advancedFilters>
    <button-filter [nbFilters]="activeFiltersCount" (clickButton)="toggleSidenav()"></button-filter>
  </ng-template>
</ng-template>

<ng-template #filtersTemplate>
  <ng-container *ngIf="isFilterOpen">
    <building-filter
      [sidenav]="sideNav"
      [filters]="filters"
      (onClear)="clearTextFilter()"
      (onFilter)="applyAdvancedFilter($event)"
    ></building-filter>
  </ng-container>
</ng-template>

<app-sidenav #sidenav [content]="buildingTemplate" [contentSidenav]="filtersTemplate"></app-sidenav>
